exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-primary[data-v-74130ab8]{border-radius:0 3px 3px 0}.stock-notification-input[data-v-74130ab8]{border-radius:3px 0 0 3px}", ""]);

// exports
